// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70e2bafe","455":"d44e2000","977":"5cbc5dc7"}[chunkId] + ".chunk.js";
};